document.addEventListener("DOMContentLoaded", function () {
  var titles = document.querySelectorAll(".js-climate-badge_content-title");
  titles.forEach(function (title) {
    title.addEventListener("click", function (e) {
      var content = e.target.closest(".climate-badge_content").querySelector(".climate-badge_content-items");
      if (content.style.display === "none" || !content.style.display) {
        title.classList.add("active");
        content.style.display = "flex";
      } else {
        content.style.display = "none";
        title.classList.remove("active");
      }
    });
  });
});
